import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";

import {claimBonusOffer, fetchBonusInfo} from "./BonusActions";
import {BonusStoreState, RequestState} from "./BonusReducer";
import {BonusConfig, BonusUpcomingOffer, UserBonusView} from "../http/protocol";
import "./BonusPage.scss";
import Translator from "../Translator";
import {BonusDetailPanel} from "./BonusDetailPanel";
import {t} from "../i18n";
import {showCashier} from "../payments/DepositActions";

/* getNextBonusesAward(){
    if(this.props.bonus && this.props.bonus.nextBonuses){
        return this.props.bonus.nextBonuses.filter((b)=> b.award).filter(n => n.bonusConfig?.id === this.props.displayTermsForBonusConfigId)
    }
     award={true} nextBonusExpires={1682294400000} 
} */

interface State {

}

interface Props {
    fetchBonusInfo() : any;
    showCashier() : void;
    bonus : BonusStoreState;
    currentBonusConfig? : BonusConfig;
    activeBonus? : UserBonusView;
    bonusConfigId? : number;
    award?: boolean;
    nextBonusExpires?: number;
    
}
export class BonusTerms extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { }
    }

    componentDidMount(): void {
        let bonusState = this.props.bonus;
        if(bonusState.activeBonusesState != RequestState.OK
            && bonusState.nextBonusesState != RequestState.OK
            && bonusState.offerState != RequestState.OK) {
            this.props.fetchBonusInfo();
        }
    }
    getNextBonusesAward(){
        let nextBonus: BonusUpcomingOffer[] = [] 
        if(this.props.bonus && this.props.bonus.nextBonuses){
            nextBonus = this.props.bonus.nextBonuses.filter((b)=> b.award).filter(n => n.bonusConfig?.id === this.props.bonusConfigId)
            if(nextBonus.length > 0){
                return {award: nextBonus[0].award, expires: nextBonus[0].expiry}
            } else {
                return undefined
            }
        }
    }

    render() {
        if(!this.props.bonus){
            return <div/>
        }
        let currentBonusConfig = this.props.currentBonusConfig;
        if(!currentBonusConfig) {
            return <div></div>
        }
        const nextBousAward = this.getNextBonusesAward();
        const currentOffer = this.props.bonus.offers?.find(bo => bo.bonusConfig?.id == currentBonusConfig!.id)

        const currency = currentBonusConfig.monetaryConfig && currentBonusConfig.monetaryConfig.currencyCode;
        let howToDetail = t("bonus.bonusHowToGetDetail", { currency : currency});
        const slugClassList = currentBonusConfig.name && currentBonusConfig.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

        return (
            <>
                <h3 className={"bonus-name"}>
                    {t("bonus.bonusTerms")} -&nbsp;
                    {currentBonusConfig.translations && <Translator defaultTranslation={currentBonusConfig.name} translations={currentBonusConfig.translations.map(t=>({lng : t.language, value : t.name})) as any} />}
                </h3>
                <div className={"bonus-description"}>
                    {currentBonusConfig.translations && <Translator defaultTranslation={currentBonusConfig.description} translations={currentBonusConfig.translations.map(t=>({lng : t.language, value : t.description})) as any} />}
                </div>
                <h5 className={"bonus-terms-title "}>
                    <i className={"material-icons"}>gavel</i> {t("bonus.bonusGeneralTerms")}
                </h5>
                {currentBonusConfig.monetaryConfig && currentBonusConfig.expiresAfterDays && 
                    <BonusDetailPanel mc={currentBonusConfig.monetaryConfig} bonusConfig={currentBonusConfig} 
                        bonusActive={this.props.activeBonus} 
                        award={nextBousAward && nextBousAward.award }
                        nextBonusExpires={nextBousAward && nextBousAward.expires}
                        bonusOffer={currentOffer}
                        tc={currentBonusConfig.turnoverContributions} expires={currentBonusConfig.expiresAfterDays} 
                        bonusNameSlug={slugClassList}
                    />
                }
                <h5 className={"bonus-terms-title"}>
                    <i className={"material-icons"}>radar</i> {t("bonus.bonusHowToGet")}
                </h5>
                <div className={"details-item"}><span>{howToDetail}</span></div>
                <div className={"button-container deposit-get-bonus"}>
                    <button onClick={() => this.props.showCashier?.()} className="btn btn-cta small">
                        {t("global.depositButton")}
                    </button>
                </div>
            </>
        )
    }
}



const mapStateToProps = (appState : AppState, props : Props) => {
    let currentBonusConfig;
    let depositButtonText = "";
    let activeBonus: UserBonusView | undefined;

    if(!props.bonusConfigId) {
        return {
            bonus : appState.bonus
        };
    }
    let id = props.bonusConfigId
    if(appState.bonus.offers) {
        let bonusConfigs  = appState.bonus.offers.map(o => o.bonusConfig);
        currentBonusConfig = bonusConfigs.find(b => b ? (b.id == id) : false );
    }
    if(!currentBonusConfig && appState.bonus.nextBonuses) {
        currentBonusConfig = appState.bonus.nextBonuses.find(b =>  b.bonusConfig?.id == id)?.bonusConfig;
    }
    if (appState.bonus.activeBonuses && appState.bonus.activeBonuses.length > 0) {

        let bonusConfigs  = appState.bonus.activeBonuses.map(o => o.bonusConfig);
        currentBonusConfig = bonusConfigs.find(b => b ? (b.id == id) : false );
        activeBonus = appState.bonus.activeBonuses.find(ub => ub.bonusConfig?.id == id);
    }
    if(!currentBonusConfig) {
        return {
            bonus : appState.bonus
        };
    }

    return {
        bonus : appState.bonus,
        currentBonusConfig : currentBonusConfig,
        activeBonus: activeBonus
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchBonusInfo : () => dispatch(fetchBonusInfo() as any),
        showCashier : () => dispatch(showCashier(true)),
        claim : (offerId : number) => offerId && dispatch(claimBonusOffer(offerId) as any)

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(BonusTerms) as any;